import { render, staticRenderFns } from "./CommentRepliesList.vue?vue&type=template&id=20316765&scoped=true"
import script from "./CommentRepliesList.vue?vue&type=script&lang=js"
export * from "./CommentRepliesList.vue?vue&type=script&lang=js"
import style0 from "./CommentRepliesList.vue?vue&type=style&index=0&id=20316765&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20316765",
  null
  
)

export default component.exports